// scheman/VoStationsPanel.jsx
import React, { useEffect, useState } from 'react';
import { fetchWithAuth } from '../services/api';
import EditorWrapper from './EditorWrapper';
import { useLoading } from '../contexts/GlobalStateContext';
import './VoStationsPanel.css';

// Ren läsvy — ingen redigering/samarbete i denna vy, så inga lås/typing-props
// behöver kopplas till stationsblocken.
const NOOP = () => {};

// Visar scheman för flera stationer (ett Verksamhetsområde) i samma vy, i given
// ordning, staplade utan mellanrum i en gemensam ram. Höger sidopanel (Kontroll
// dagbesked, Medåk/Student, Blankpass, Utbildning, Intresse för gnet) hanteras och
// slås ihop serverside (se /api/editableschema/vo) så den bara visas för första
// stationen med underlag, med samma vybredd bevarad för övriga stationer.
//
// Delas mellan SchemaVoView.jsx (egen sida) och SchemaView.jsx (Standard-flödets
// station/VO-väljare).
const VoStationsPanel = ({ stations, date }) => {
  const [schedules, setSchedules] = useState({});
  const { setLoading } = useLoading();

  useEffect(() => {
    if (!stations || stations.length === 0) {
      setSchedules({});
      return;
    }

    let cancelled = false;
    setLoading(true);

    const loadAll = async () => {
      try {
        const stationerParam = stations.map(encodeURIComponent).join(',');
        const url = `/api/editableschema/vo?date=${date}&stations=${stationerParam}`;
        const response = await fetchWithAuth(url);
        const data = response.ok ? await response.json() : [];
        const bySt = Object.fromEntries(data.map(r => [r.station, { html: r.html }]));
        if (!cancelled) setSchedules(bySt);
      } catch {
        if (!cancelled) setSchedules({});
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadAll();
    return () => { cancelled = true; };
  }, [stations, date]);

  const stationerUtanUnderlag = stations.filter(station => {
    const schedule = schedules[station];
    return schedule && (schedule.html === '---' || !schedule.html);
  });

  return (
    <>
      <div className="vo-stations-panel tw-mx-4 tw-mb-4 tw-p-4" style={{ border: '4px double black', backgroundColor: '#FFFF99' }}>
        {stations
          .filter(station => {
            const schedule = schedules[station];
            return schedule && schedule.html && schedule.html !== '---';
          })
          .map((station) => (
            <div key={station}>
              <EditorWrapper
                originalHtml={schedules[station].html}
                conflicts={[]}
                isStandardUser={true}
                isEdited={false}
                currentDate={date}
                station={station}
                typingUsers={{}}
                editLocks={{}}
                myLocks={{}}
                onStartTyping={NOOP}
                onStopTyping={NOOP}
                onRequestLock={NOOP}
                onReleaseLock={NOOP}
                onDocumentSaved={NOOP}
                onNotifyDocumentSaved={NOOP}
                selectDates={false}
                onEditModeChange={NOOP}
                hideStatusBar={true}
                hideHeader={false}
              />
            </div>
          ))}
      </div>

      {stationerUtanUnderlag.length > 0 && (
        <div className="tw-mx-4 tw-mb-4 tw-text-gray-500 tw-text-sm">
          Underlag saknas för: {stationerUtanUnderlag.join(', ')}
        </div>
      )}
    </>
  );
};

export default VoStationsPanel;
